'use client';

import React from 'react';
import styles from './PresentationOfSection.module.scss';

export type PresentationOfSectionProps = {
    title?: string;
    description?: string;
    align?: 'left' | 'center';
    className?: string;

    /** Show underline under the title (default: true) */
    underline?: boolean;

    /** Optional AOS hook without forcing AOS everywhere */
    aos?: {
        animation?: string; // default: "fade-up"
        delay?: number;     // default: 0
    };
};

export default function PresentationOfSection({
    title,
    description,
    align = 'center',
    className,
    aos,
    underline = false,
}: PresentationOfSectionProps) {
    if (!title && !description) return null;

    return (
        <header
            className={[styles.header, align === 'left' ? styles.left : styles.center, className]
                .filter(Boolean)
                .join(' ')}
            data-aos={aos?.animation ?? ''}
            data-aos-delay={typeof aos?.delay === 'number' ? aos.delay : undefined}
        >
            {title && (
                <h2 className={[styles.title, underline ? '' : styles.noUnderline].filter(Boolean).join(' ')}>
                    {title}
                </h2>
            )}
            {description && <p className={styles.subtitle}>{description}</p>}
        </header>
    );
}